import { isMobileOrTablet} from '@/utils'
import { useNuxtApp } from '#app'
let observers: [IntersectionObserver] = [];
let viewPages = {}
let lastPageIndex = 0;
export const lazyRender = (elements: HTMLElement[], array, option : {scale?: number, width: number, height?: number, isInit?: boolean, userLevel: number,
    buttonCallback?: Function, notRenderTextLayer?: boolean, renderEditTextLayer?: Function}, canvasName?:string, transNum?: number, watermarks?: object, waterStr?: string)=> {
    console.log('xs array', elements.length, array.length, transNum, watermarks, waterStr);
    const { $i18n } = useNuxtApp()
    const t = $i18n.t
    const observer = new IntersectionObserver((entries => {
        entries.forEach((entry : IntersectionObserverEntry)=> {
            if(option.isInit && !entry.target.reFinish){
                entry.target.isRendering = false
                entry.target.finish = false
                entry.target.reFinish = true
            }
            const images = entry.target.getElementsByTagName("img")
            if(images.length == 0){
                const img = document.createElement('img');
                img.style.width = "50px"
                img.style.height = "50px"
                img.style.position = "absolute"
                img.style.alignSelf = 'center'
                img.style.left = '50%'
                img.style.marginLeft = "-25px"
                img.style.zIndex = String(100)
                img.src = `data:image/gif;base64,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`;
                entry.target.appendChild(img)
            }

            // const ps = entry.target.getElementsByTagName("p")
            // if(ps.length == 0){
            //     const img = document.createElement('p');
            //     img.style.minWidth = "50px"
            //     img.style.height = "50px"
            //     img.style.position = "absolute"
            //     img.style.alignSelf = 'center'
            //     img.style.left = '50%'
            //     img.style.transform = `translate(-50%, -50%)`
            //     img.style.zIndex = String(1)
            //     img.style.fontSize = "24px"
            //     img.style.color = "#F09308"
            //     img.style.display = 'none'
            //     img.textContent = waterStr ? waterStr : t("untranslated")
            //     img.style.textShadow = '4px 4px 4px rgba(0, 0, 0, 0.8);'
            //     entry.target.appendChild(img)
            // }
            console.log("asadadad 3333===", entry.target.isRendering, entry.isIntersecting, entry.target.finish, option, entry.target['dataset'].index)
            if(!entry.target.isRendering && entry.isIntersecting && !entry.target.finish){
                const index = entry.target['dataset'].index
                const page = array[index - 1];
                console.log("xs page", page)
                entry.target.isRendering = true;
                let canvas;
                if (canvasName && document.getElementById(canvasName + index)) {
                    canvas = document.getElementById(canvasName + index)
                }else {
                    canvas = document.createElement('canvas')
                    if (canvasName) {
                        canvas.setAttribute("id", canvasName + index)
                    }
                }
                // let context = canvas.getContext("2d");
                // useNuxtApp().$PdfUtils.initViewData(context)
                // const [x1, , x2] = page._pageInfo.view;
                // const pageWidth = x2 - x1;

                // const devicePixelRatio = window.devicePixelRatio || 1;
                // // 缩放比例 - 修复：正确处理 option.scale 和 devicePixelRatio
                // let myScale = (option.width / pageWidth) * (option.scale || 1) * devicePixelRatio;
                
                // let pageRotation = useNuxtApp().$PdfUtils.getPdfPageRotation(page)
                // if (![0, 90, 180, 270].includes(pageRotation)) {
                //     console.error('Invalid rotation value. It must be 0, 90, 180, or 270.');
                //     pageRotation = 0; // 设置为默认值
                // }

                // let viewport = page.getViewport({scale: myScale,rotation: pageRotation });
                
                // // const myScale = option.scale ? option.width * option.scale / pageWidth : option.width / pageWidth
                // // let viewport = page.getViewport({scale: myScale * 2});
                // canvas.width = viewport.width
                // canvas.height = viewport.height;
                // if ( pageRotation === 90 || pageRotation === 270) {
                //     canvas.height = viewport.width;
                //     canvas.width = viewport.height;
                //     canvas.style.zIndex = '1';
                //     canvas.style.position = 'relative';
                // } else {
                //     canvas.height = viewport.height;
                //     canvas.width = viewport.width;
                // }
                // // 修复：设置显示尺寸为固定宽度，而不是 viewport 的实际像素尺寸
                // canvas.style.width = option.width + 'px';
                // canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
                // canvas.setAttribute("_pageWidth", `${option.width}`)
                // canvas.setAttribute("_pageHeight", `${viewport.height / devicePixelRatio}`)
                // canvas.setAttribute("_transform", `${JSON.stringify(viewport.transform)}`)
                // canvas.setAttribute("_viewBox", `${JSON.stringify(viewport.viewBox)}`)
                // canvas.setAttribute("_rotation", `${ viewport.rotation}`)
                // console.log("asadadad 2222 === ", viewport, myScale, option.width, pageWidth, devicePixelRatio)
                // // 禁用抗锯齿
                // context.imageSmoothingEnabled = false;


                let context = canvas.getContext("2d");
                useNuxtApp().$PdfUtils.initViewData(context)
                const [x1, , x2] = page._pageInfo.view;
                let pageWidth = x2 - x1;
                const devicePixelRatio = window.devicePixelRatio || 1;
                // 缩放比例
                let myScale = (option.width / pageWidth) * devicePixelRatio;
                let viewport = page.getViewport({scale: myScale, rotation: page.rotate});
                viewPages[index] = page.getViewport({scale: 1, rotation: page.rotate});
                if ((viewport.rotation + 360) % 90 === 0 && (viewport.rotation + 360) % 180 !== 0) {
                    pageWidth = page._pageInfo.view[3] - page._pageInfo.view[1]
                    let testScale = (option.width / pageWidth) * devicePixelRatio;
                    viewport = page.getViewport({scale: testScale, rotation: page.rotate});
                    canvas.width = viewport.width
                    canvas.height = viewport.height;
                    canvas.setAttribute("_pageWidth", `${option.width / myScale}`)
                    canvas.setAttribute("_pageHeight", `${viewport.height}`)
                    canvas.setAttribute("_transform", `${JSON.stringify(viewport.transform)}`)
                    canvas.setAttribute("_viewBox", `${JSON.stringify(viewport.viewBox)}`)
                    canvas.setAttribute("_rotation", `${ viewport.rotation}`)
                }else {
                    canvas.width = viewport.width
                    canvas.height = viewport.height;
                    // canvas.style.width = viewport.width + 'px';
                }
                canvas.style.width = option.width + 'px';
                canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
                console.log("asadadad 2222 === init",viewport, myScale, option.width, pageWidth, devicePixelRatio)
                // 禁用抗锯齿
                context.imageSmoothingEnabled = false;
                // context.scale(devicePixelRatio, devicePixelRatio)

                // if (watermarks && watermarks[index]) {
                //     if(transNum && transNum > 0 && index > transNum) {
                //         canvas.style.filter = 'blur(16px)'
                //     }else {
                //         let waterCanvas;
                //         if (canvasName && document.getElementById(`water-${canvasName}${index}`)) {
                //             waterCanvas = document.getElementById(`water-${canvasName}${index}`)
                //         }else {
                //             waterCanvas = document.createElement('canvas')
                //             if (canvasName) {
                //                 waterCanvas.setAttribute("id", `water-${canvasName}${index}`)
                //             }
                //             waterCanvas.style.position = 'absolute'
                //             waterCanvas.style.inset = '0'
                //             waterCanvas.style.width = option.width + 'px';
                //             waterCanvas.style.pointerEvents = "none"
                //             waterCanvas.style.display = "flex"
    
                //             waterCanvas.style.zIndex = 2
                //             const ctx = waterCanvas.getContext('2d');
                //             waterCanvas.width = viewport.width
                //             waterCanvas.height = viewport.height
                //             // 设置水印样式
                //             ctx.font = '70px Arial';
                //             ctx.fillStyle = 'rgba(0, 0, 0, 0.4)'; // 水印颜色和透明度
                //             ctx.textAlign = 'center';
                //             ctx.textBaseline = 'middle';
                //             const angle = -45; // 水印旋转角度
                //             var textWidth = ctx.measureText(waterStr ? waterStr : t("watermark-title")).width;
                //             var textHeight = ctx.measureText(waterStr ? waterStr : t("watermark-title")).height;
                //             const spacingW = 100 + textWidth;
                //             // 绘制水印
                //             // for (let x = textWidth / 2; x < waterCanvas.width; x += spacingW) {
                //             //     for (let y = textWidth / 2; y < waterCanvas.height; y += 400) {
                //             //         ctx.save();
                //             //         ctx.translate(x, y);
                //             //         ctx.rotate((angle * Math.PI) / 180);
                //             //         ctx.fillText(t("watermark-title"), 0, 0);
                //             //         ctx.restore();
                //             //     }
                //             // }
    
    
                //             ctx.save();
                //             ctx.translate(waterCanvas.width / 2, waterCanvas.height / 2 - 25);
                //             ctx.rotate((angle * Math.PI) / 180);
                //             ctx.fillText(waterStr ? waterStr : t("watermark-title"), 0, 0, waterCanvas.width - 100);
                //             ctx.restore();  
                //             ctx.scale(option.scale, option.scale)
                //             entry.target.appendChild(waterCanvas)
                //             console.log("asdasdada==", waterCanvas.width , textWidth, option.width)
                //         }
                //     }
                // } else {
                //     if(transNum && transNum > 0 && index > transNum) {
                //         canvas.style.filter = 'blur(16px)'
                //     }
                // }
                console.log("asadadad 4444===", transNum, index, option)
                
                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                }
                let task = page.render(renderContext)
                if(option.renderEditTextLayer){
                    option.renderEditTextLayer(index, viewport, entry.target, page)
                }
                task.promise.then(()=> {
                    entry.target.appendChild(canvas);
                    entry.target.finish = true
                    const images = entry.target.getElementsByTagName('img')
                    if(images.length) {
                        images[0].style.display = "none"
                    }
                    // if (watermarks && watermarks[index]) {
                    //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                    //         ps[0].style.display = "flex"
                    //     }
                    // }else {
                    //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                    //         ps[0].style.display = "flex"
                    //     }
                    // }
                    if (watermarks && watermarks[index]) {
                        createWater({
                            canvasName: canvasName,
                            index: index,
                            text: waterStr? waterStr : t("watermark-title"),
                            paraseDiv: entry.target
                        })
                        if(transNum && transNum > 0 && index > transNum) {
                            createMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }else {
                            removeMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }
                    }else {
                        if(transNum && transNum > 0 && index > transNum) {
                            createMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }else {
                            removeMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }
                    }
                    if (option.notRenderTextLayer) return ;
                    return page.getTextContent();
                }).then(async (textContent)=>{
                    // 创建文本
                    if (!textContent) return ;
                    if (document.getElementById(`${canvasName}textLayer-${index}`)) {
                        const textLayerDiv = document.getElementById(`${canvasName}textLayer-${index}`)
                        const canvas = document.getElementsByTagName('canvas')
                        const textLayerDivWidth = canvas[0].width || 0
                        const textLayerDivHeight = canvas[0].height || 0
                        var textLayer = await useNuxtApp().$PdfUtils.getTextLayerBuilder();
                        console.log("textLayer==",textLayer, textLayerDivWidth, textLayerDivHeight, myScale)
                        textLayer.div = textLayerDiv
                        textLayer.setTextContentSource(textContent);
                        textLayer.render(viewport);

                        // 应用文本颜色修改
                        applyTextColorModificationsForLazy(textLayerDiv!, index);
                    }else {
                        const textLayerDiv = document.createElement('div')
                        const canvas = document.getElementsByTagName('canvas')
                        const textLayerDivWidth = canvas[0].width || 0
                        const textLayerDivHeight = canvas[0].height || 0
                        textLayerDiv.setAttribute('class', 'textLayer')
                        textLayerDiv.setAttribute('style', `width: ${textLayerDivWidth}px;height:${textLayerDivHeight}px;`)
                        textLayerDiv.setAttribute('id', `${canvasName}textLayer-${index}`)
                        entry.target.appendChild(textLayerDiv);
                        var textLayer = await useNuxtApp().$PdfUtils.getTextLayerBuilder();
                        console.log("textLayer==",textLayer, textLayerDivWidth, textLayerDivHeight, myScale)
                        textLayer.div = textLayerDiv
                        textLayer.setTextContentSource(textContent);
                        textLayer.render(viewport);

                        // 应用文本颜色修改
                        applyTextColorModificationsForLazy(textLayerDiv, index);
                    }
                });
            }
        })
    }))
    elements.forEach(ele=> {
        observer.observe(ele)
    })
    observers.push(observer)
}

export const lazyRenderEditPdf = (elements: HTMLElement[], array, option : {scale?: number, width: number, height?: number, isInit?: boolean, userLevel: number,
    buttonCallback?: Function, notRenderTextLayer?: boolean, renderEditTextLayer?: Function}, canvasName?:string, transNum?: number, watermarks?: object, waterStr?: string)=> {
    console.log('xs array', elements.length, array.length, transNum, watermarks, waterStr);
    const { $i18n } = useNuxtApp()
    const t = $i18n.t
    const observer = new IntersectionObserver((entries => {
        entries.forEach((entry : IntersectionObserverEntry)=> {
            if(option.isInit && !entry.target.reFinish){
                entry.target.isRendering = false
                entry.target.finish = false
                entry.target.reFinish = true
            }
            const images = entry.target.getElementsByTagName("img")
            if(images.length == 0){
                const img = document.createElement('img');
                img.style.width = "50px"
                img.style.height = "50px"
                img.style.position = "absolute"
                img.style.alignSelf = 'center'
                img.style.left = '50%'
                img.style.marginLeft = "-25px"
                img.style.zIndex = String(100)
                img.src = `data:image/gif;base64,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`;
                entry.target.appendChild(img)
            }

            // const ps = entry.target.getElementsByTagName("p")
            // if(ps.length == 0){
            //     const img = document.createElement('p');
            //     img.style.minWidth = "50px"
            //     img.style.height = "50px"
            //     img.style.position = "absolute"
            //     img.style.alignSelf = 'center'
            //     img.style.left = '50%'
            //     img.style.transform = `translate(-50%, -50%)`
            //     img.style.zIndex = String(1)
            //     img.style.fontSize = "24px"
            //     img.style.color = "#F09308"
            //     img.style.display = 'none'
            //     img.textContent = waterStr ? waterStr : t("untranslated")
            //     img.style.textShadow = '4px 4px 4px rgba(0, 0, 0, 0.8);'
            //     entry.target.appendChild(img)
            // }
            console.log("asadadad 3333===", entry.target.isRendering, entry.isIntersecting, entry.target.finish, option, entry.target['dataset'].index)
            if(!entry.target.isRendering && entry.isIntersecting && !entry.target.finish){
                const index = entry.target['dataset'].index
                const page = array[index - 1];
                console.log("xs page", page)
                entry.target.isRendering = true;
                let canvas;
                if (canvasName && document.getElementById(canvasName + index)) {
                    canvas = document.getElementById(canvasName + index)
                }else {
                    canvas = document.createElement('canvas')
                    if (canvasName) {
                        canvas.setAttribute("id", canvasName + index)
                    }
                }
                let context = canvas.getContext("2d");
                useNuxtApp().$PdfUtils.initViewData(context)
                const [x1, , x2] = page._pageInfo.view;
                const pageWidth = x2 - x1;

                const devicePixelRatio = window.devicePixelRatio || 1;
                // 缩放比例 - 修复：正确处理 option.scale 和 devicePixelRatio
                let myScale = (option.width / pageWidth) * (option.scale || 1) * devicePixelRatio;
                
                let pageRotation = useNuxtApp().$PdfUtils.getPdfPageRotation(page)
                if (![0, 90, 180, 270].includes(pageRotation)) {
                    console.error('Invalid rotation value. It must be 0, 90, 180, or 270.');
                    pageRotation = 0; // 设置为默认值
                }

                let viewport = page.getViewport({scale: myScale,rotation: pageRotation });
                
                // const myScale = option.scale ? option.width * option.scale / pageWidth : option.width / pageWidth
                // let viewport = page.getViewport({scale: myScale * 2});
                canvas.width = viewport.width
                canvas.height = viewport.height;
                if ( pageRotation === 90 || pageRotation === 270) {
                    canvas.height = viewport.width;
                    canvas.width = viewport.height;
                    canvas.style.zIndex = '1';
                    canvas.style.position = 'relative';
                } else {
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                }
                // 修复：设置显示尺寸为固定宽度，而不是 viewport 的实际像素尺寸
                canvas.style.width = option.width + 'px';
                canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
                canvas.setAttribute("_pageWidth", `${option.width}`)
                canvas.setAttribute("_pageHeight", `${viewport.height / devicePixelRatio}`)
                canvas.setAttribute("_transform", `${JSON.stringify(viewport.transform)}`)
                canvas.setAttribute("_viewBox", `${JSON.stringify(viewport.viewBox)}`)
                canvas.setAttribute("_rotation", `${ viewport.rotation}`)
                console.log("asadadad 2222 === ", viewport, myScale, option.width, pageWidth, devicePixelRatio)
                // 禁用抗锯齿
                context.imageSmoothingEnabled = false;

                // if (watermarks && watermarks[index]) {
                //     if(transNum && transNum > 0 && index > transNum) {
                //         canvas.style.filter = 'blur(16px)'
                //     }else {
                //         let waterCanvas;
                //         if (canvasName && document.getElementById(`water-${canvasName}${index}`)) {
                //             waterCanvas = document.getElementById(`water-${canvasName}${index}`)
                //         }else {
                //             waterCanvas = document.createElement('canvas')
                //             if (canvasName) {
                //                 waterCanvas.setAttribute("id", `water-${canvasName}${index}`)
                //             }
                //             waterCanvas.style.position = 'absolute'
                //             waterCanvas.style.inset = '0'
                //             waterCanvas.style.width = option.width + 'px';
                //             waterCanvas.style.pointerEvents = "none"
                //             waterCanvas.style.display = "flex"
    
                //             waterCanvas.style.zIndex = 2
                //             const ctx = waterCanvas.getContext('2d');
                //             waterCanvas.width = viewport.width
                //             waterCanvas.height = viewport.height
                //             // 设置水印样式
                //             ctx.font = '70px Arial';
                //             ctx.fillStyle = 'rgba(0, 0, 0, 0.4)'; // 水印颜色和透明度
                //             ctx.textAlign = 'center';
                //             ctx.textBaseline = 'middle';
                //             const angle = -45; // 水印旋转角度
                //             var textWidth = ctx.measureText(waterStr ? waterStr : t("watermark-title")).width;
                //             var textHeight = ctx.measureText(waterStr ? waterStr : t("watermark-title")).height;
                //             const spacingW = 100 + textWidth;
                //             // 绘制水印
                //             // for (let x = textWidth / 2; x < waterCanvas.width; x += spacingW) {
                //             //     for (let y = textWidth / 2; y < waterCanvas.height; y += 400) {
                //             //         ctx.save();
                //             //         ctx.translate(x, y);
                //             //         ctx.rotate((angle * Math.PI) / 180);
                //             //         ctx.fillText(t("watermark-title"), 0, 0);
                //             //         ctx.restore();
                //             //     }
                //             // }
    
    
                //             ctx.save();
                //             ctx.translate(waterCanvas.width / 2, waterCanvas.height / 2 - 25);
                //             ctx.rotate((angle * Math.PI) / 180);
                //             ctx.fillText(waterStr ? waterStr : t("watermark-title"), 0, 0, waterCanvas.width - 100);
                //             ctx.restore();  
                //             ctx.scale(option.scale, option.scale)
                //             entry.target.appendChild(waterCanvas)
                //             console.log("asdasdada==", waterCanvas.width , textWidth, option.width)
                //         }
                //     }
                // } else {
                //     if(transNum && transNum > 0 && index > transNum) {
                //         canvas.style.filter = 'blur(16px)'
                //     }
                // }
                console.log("asadadad 4444===", transNum, index, option)
                
                const renderContext = {
                    canvasContext: context,
                    viewport: viewport
                }
                let task = page.render(renderContext)
                if(option.renderEditTextLayer){
                    option.renderEditTextLayer(index, viewport, entry.target, page)
                }
                task.promise.then(()=> {
                    entry.target.appendChild(canvas);
                    entry.target.finish = true
                    const images = entry.target.getElementsByTagName('img')
                    if(images.length) {
                        images[0].style.display = "none"
                    }
                    // if (watermarks && watermarks[index]) {
                    //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                    //         ps[0].style.display = "flex"
                    //     }
                    // }else {
                    //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                    //         ps[0].style.display = "flex"
                    //     }
                    // }
                    if (watermarks && watermarks[index]) {
                        createWater({
                            canvasName: canvasName,
                            index: index,
                            text: waterStr? waterStr : t("watermark-title"),
                            paraseDiv: entry.target
                        })
                        if(transNum && transNum > 0 && index > transNum) {
                            createMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }else {
                            removeMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }
                    }else {
                        if(transNum && transNum > 0 && index > transNum) {
                            createMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }else {
                            removeMark({
                                canvasName: canvasName,
                                index: index,
                                text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                paraseDiv: entry.target,
                                bottonText: t("mask-buy-botton-text"),
                                buttonClick: option.buttonCallback
                            })
                        }
                    }
                    if (option.notRenderTextLayer) return ;
                    return page.getTextContent();
                }).then(async (textContent)=>{
                    // 创建文本
                    if (!textContent) return ;
                    if (document.getElementById(`${canvasName}textLayer-${index}`)) {
                        const textLayerDiv = document.getElementById(`${canvasName}textLayer-${index}`)
                        const canvas = document.getElementsByTagName('canvas')
                        const textLayerDivWidth = canvas[0].width || 0
                        const textLayerDivHeight = canvas[0].height || 0
                        var textLayer = await useNuxtApp().$PdfUtils.getTextLayerBuilder();
                        console.log("textLayer==",textLayer, textLayerDivWidth, textLayerDivHeight, myScale)
                        textLayer.div = textLayerDiv
                        textLayer.setTextContentSource(textContent);
                        textLayer.render(viewport);
                    }else {
                        const textLayerDiv = document.createElement('div')
                        const canvas = document.getElementsByTagName('canvas')
                        const textLayerDivWidth = canvas[0].width || 0
                        const textLayerDivHeight = canvas[0].height || 0
                        textLayerDiv.setAttribute('class', 'textLayer')
                        textLayerDiv.setAttribute('style', `width: ${textLayerDivWidth}px;height:${textLayerDivHeight}px;`)
                        textLayerDiv.setAttribute('id', `${canvasName}textLayer-${index}`)
                        entry.target.appendChild(textLayerDiv);
                        var textLayer = await useNuxtApp().$PdfUtils.getTextLayerBuilder();
                        console.log("textLayer==",textLayer, textLayerDivWidth, textLayerDivHeight, myScale)
                        textLayer.div = textLayerDiv
                        textLayer.setTextContentSource(textContent);
                        textLayer.render(viewport);
                    }
                });
            }
        })
    }))
    elements.forEach(ele=> {
        observer.observe(ele)
    })
    observers.push(observer)
}

export function clearObserver() {
    for (let i = 0; i < observers.length; i++) {
        let observer = observers[i]
        observer.disconnect()
    }
}

export const lazyScaleRender = (elements: HTMLElement[], array, option : {scale?: number, width: number, height?: number, isInit?: boolean, userLevel: number, notRenderTextLayer?: boolean, buttonCallback?: Function, closeEdit?: boolean}, canvasName?:string, divName?: string, transNum?: number, watermarks?: object,  waterStr?: string)=> {
    console.log('xs array lazyScaleRender', elements.length, array, canvasName, option);
    const { $i18n } = useNuxtApp()
    const t = $i18n.t
    // array = shaw
    const observer = new IntersectionObserver((entries => {
        entries.forEach((entry : IntersectionObserverEntry)=> {
            if(option.isInit){
                entry.target.isRendering = false
                entry.target.finish = false
            }
            const images = entry.target.getElementsByTagName("img")
            if(images.length == 0){
                const img = document.createElement('img');
                img.style.width = "50px"
                img.style.height = "50px"
                img.style.position = "absolute"
                img.style.alignSelf = 'center'
                img.style.left = '50%'
                img.style.zIndex = String(100)
                img.src = `data:image/gif;base64,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`;
                entry.target.appendChild(img)
            }
            console.log("asadadad 3333===", entry.target.isRendering, entry.isIntersecting, entry.target.finish)
            if(!entry.target.isRendering && entry.isIntersecting && !entry.target.finish){
                const index = entry.target['dataset'].index
                const page = array[index - 1];
                console.log("xs page", page)
                entry.target.isRendering = true;
                let canvas;
                if (canvasName && document.getElementById(canvasName + index)) {
                    canvas = document.getElementById(canvasName + index)
                }else {
                    canvas = document.createElement('canvas')
                    if (canvasName) {
                        canvas.setAttribute("id", canvasName + index)
                    }
                }
                // let context = canvas.getContext("2d");
                // useNuxtApp().$PdfUtils.initViewData(context)
                // const [x1, , x2] = page._pageInfo.view;
                // const pageWidth = x2 - x1;

                // const devicePixelRatio = window.devicePixelRatio || 1;
                // // 缩放比例 - 修复：正确处理 option.scale 和 devicePixelRatio
                // let myScale = (option.width / pageWidth) * (option.scale || 1) * devicePixelRatio;
                
                // let pageRotation = useNuxtApp().$PdfUtils.getPdfPageRotation(page)
                // if (![0, 90, 180, 270].includes(pageRotation)) {
                //     console.error('Invalid rotation value. It must be 0, 90, 180, or 270.');
                //     pageRotation = 0; // 设置为默认值
                // }

                // let viewport = page.getViewport({scale: myScale,rotation: pageRotation });
                
                // // const myScale = option.scale ? option.width * option.scale / pageWidth : option.width / pageWidth
                // // let viewport = page.getViewport({scale: myScale * 2});
                // canvas.width = viewport.width
                // canvas.height = viewport.height;
                // if ( pageRotation === 90 || pageRotation === 270) {
                //     canvas.height = viewport.width;
                //     canvas.width = viewport.height;
                //     canvas.style.zIndex = '1';
                //     canvas.style.position = 'relative';
                // } else {
                //     canvas.height = viewport.height;
                //     canvas.width = viewport.width;
                // }
                // // 修复：设置显示尺寸为固定宽度，而不是 viewport 的实际像素尺寸
                // canvas.style.width = viewport.width / devicePixelRatio + 'px';
                // canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
                // canvas.setAttribute("_pageWidth", `${option.width}`)
                // canvas.setAttribute("_pageHeight", `${viewport.height / devicePixelRatio}`)
                // canvas.setAttribute("_transform", `${JSON.stringify(viewport.transform)}`)
                // canvas.setAttribute("_viewBox", `${JSON.stringify(viewport.viewBox)}`)
                // canvas.setAttribute("_rotation", `${ viewport.rotation}`)
                // console.log("asadadad 2222 === ", viewport, myScale, option.width, pageWidth, devicePixelRatio)
                // // 禁用抗锯齿
                // context.imageSmoothingEnabled = false;

                let context = canvas.getContext("2d");
                useNuxtApp().$PdfUtils.initViewData(context)
                const [x1, , x2] = page._pageInfo.view;
                let pageWidth = x2 - x1;
                const devicePixelRatio = window.devicePixelRatio || 1;
                // 缩放比例
                let myScale = (option.width / pageWidth) * (option.scale || 1) * devicePixelRatio;
                let viewport = page.getViewport({scale: myScale, rotation: page.rotate});
                if ((viewport.rotation + 360) % 90 === 0 && (viewport.rotation + 360) % 180 !== 0) {
                    pageWidth = page._pageInfo.view[3] - page._pageInfo.view[1]
                    let testScale = (option.width / pageWidth) * (option.scale || 1) * devicePixelRatio
                    viewport = page.getViewport({scale: testScale, rotation: page.rotate});
                    canvas.width = viewport.width 
                    canvas.height = viewport.height;
                    canvas.setAttribute("_pageWidth", `${option.width / myScale}`)
                    canvas.setAttribute("_pageHeight", `${viewport.height}`)
                    canvas.setAttribute("_transform", `${JSON.stringify(viewport.transform)}`)
                    canvas.setAttribute("_viewBox", `${JSON.stringify(viewport.viewBox)}`)
                    canvas.setAttribute("_rotation", `${ viewport.rotation}`)
                }else {
                    canvas.width = viewport.width
                    canvas.height = viewport.height;
                    // canvas.style.width = viewport.width + 'px';
                }
                canvas.style.width = (viewport.width / devicePixelRatio) + 'px';
                canvas.style.height = (viewport.height / devicePixelRatio) + 'px';
                console.log("asadadad 2222 === init",viewport, myScale, option.width, pageWidth, devicePixelRatio)
                // 禁用抗锯齿
                context.imageSmoothingEnabled = false;

                const renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                }
                try {
                    let task = page.render(renderContext)
                    task.promise.then(()=> {
                        entry.target.appendChild(canvas);
                        entry.target.finish = true
                        const images = entry.target.getElementsByTagName('img')
                        if(images.length) {
                            images[0].style.display = "none"
                        }
                        // if (watermarks && watermarks[index]) {
                        //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                        //         ps[0].style.display = "flex"
                        //     }
                        // }else {
                        //     if(transNum && transNum > 0 && ps.length && index > transNum) {
                        //         ps[0].style.display = "flex"
                        //     }
                        // }
                        if (watermarks && watermarks[index]) {
                            createWater({
                                canvasName: canvasName,
                                index: index,
                                text: waterStr? waterStr : t("watermark-title"),
                                paraseDiv: entry.target
                            })
                            if(transNum && transNum > 0 && index > transNum) {
                                createMark({
                                    canvasName: canvasName,
                                    index: index,
                                    text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                    paraseDiv: entry.target,
                                    bottonText: t("mask-buy-botton-text"),
                                    buttonClick: option.buttonCallback  
                                })
                            }
                        }else {
                            if(transNum && transNum > 0 && index > transNum) {
                                createMark({
                                    canvasName: canvasName,
                                    index: index,
                                    text: option.userLevel <= 0 ? t("untranslated") : t("untranslated-vip"),
                                    paraseDiv: entry.target,
                                    bottonText: t("mask-buy-botton-text"),
                                    buttonClick: option.buttonCallback
                                })
                            }
                        }
                        if (option.notRenderTextLayer) {
                            return;
                        }
                        return page.getTextContent();
                    }).then(async (textContent)=>{
                        // 创建文本
                        if (option.notRenderTextLayer) {
                            return;
                        }
                        let textLayerDiv;
                        const canvas = document.getElementsByTagName('canvas')
                        const textLayerDivWidth = viewport.width 
                        const textLayerDivHeight = viewport.height
                       
                        if (document.getElementById(`${canvasName}textLayer-${index}`)) {
                            textLayerDiv = document.getElementById(`${canvasName}textLayer-${index}`)
                            // textLayerDiv.style.width = textLayerDivWidth + 'px'
                            // textLayerDiv.style.height = textLayerDivHeight + 'px'
                            console.log("textLayerDivWidth 1111", textLayerDivWidth, textLayerDivHeight, viewport, canvasName)
                        }else {
                            textLayerDiv = document.createElement('div')
                            textLayerDiv.setAttribute('class', 'textLayer')
                            textLayerDiv.setAttribute('id', `${canvasName}textLayer-${index}`)
                            entry.target.appendChild(textLayerDiv);
                            console.log("textLayerDivWidth 2222", textLayerDivWidth, textLayerDivHeight, viewport, canvasName)
                        }
                        textLayerDiv.setAttribute('style', `width: ${textLayerDivWidth}px;height:${textLayerDivHeight}px;`)

                        var textLayer = await useNuxtApp().$PdfUtils.getTextLayerBuilder();
                        textLayer.div = textLayerDiv
                        textLayer.setTextContentSource(textContent);
                        textLayer.render(viewport);
   
                        // 渲染高亮文本
                        applyTextColorModificationsForLazy(textLayerDiv!, index);
                    });
                }catch (e) {
                    console.log('e', e)
                }
            }
        })
    }))
    elements.forEach(ele=> {
        observer.observe(ele)
    })
    observers.push(observer)
}

// 添加水印
const createWater = (waterMarkConfig)=>{
    let div;
    if (document.getElementById(`water-${waterMarkConfig.canvasName}${waterMarkConfig.index}`)) {
        div = document.getElementById(`water-${waterMarkConfig.canvasName}${waterMarkConfig.index}`)
    }else {
        div = document.createElement('div')
        if (waterMarkConfig.canvasName) {
            div.setAttribute("id", `water-${waterMarkConfig.canvasName}${waterMarkConfig.index}`)
        }
        div.style.width = "100%"
        div.style.height = "100%"
        div.style.position = "absolute";
        div.style.inset = 0
        div.style.display = 'flex'
        div.style.justifyContent = 'center';
        div.style.alignItems = 'center'
        const p = document.createElement('p')
        p.innerText = waterMarkConfig.text
        p.style.fontSize = "40px"
        p.style.color = 'rgba(0,0,0,0.6)'
        p.style.opacity = '0.6'
        p.style.transform = "rotate(-45deg)"
        div.appendChild(p)
        waterMarkConfig.paraseDiv.appendChild(div)
    }
    return div;
}

// 移除遮照
const removeMark = (maskConfig)=>{
    let div;
    console.log("removeMark",maskConfig, document.getElementById(`mark-${maskConfig.canvasName}${maskConfig.index}`))
    if (document.getElementById(`mark-${maskConfig.canvasName}${maskConfig.index}`)) {
        div = document.getElementById(`mark-${maskConfig.canvasName}${maskConfig.index}`)
        div.style.display = 'none'
        console.log("removeMark 222")
    }
    console.log("removeMark")
}

// 添加遮罩层
const createMark = (maskConfig)=>{
    console.log("createMark", maskConfig)
    let div;
    if (document.getElementById(`mark-${maskConfig.canvasName}${maskConfig.index}`)) {
        div = document.getElementById(`mark-${maskConfig.canvasName}${maskConfig.index}`)
        div.style.display = 'flex'
    }else {
        div = document.createElement('div')
        if (maskConfig.canvasName) {
            div.setAttribute("id", `mark-${maskConfig.canvasName}${maskConfig.index}`)
        }
        div.style.width = "100%"
        div.style.height = "100%"
        div.style.position = "absolute";
        div.style.inset = 0
        div.style.display = 'flex'
        div.style.justifyContent = 'center';
        div.style.background = 'rgba(255,255,255,0.6)'
        div.style.backdropFilter = 'blur(10px)'
        div.style.alignItems = 'center'
        div.style.flexDirection = 'column';
        div.style.zIndex = 3
        const span = document.createElement('span')
        span.innerText = maskConfig.text
        span.style.color = '#F09308'
        span.style.fontSize = '24px'
        span.style.margin = '0 20px'
        if(process.client && isMobileOrTablet()){
            span.style.fontSize = '20px'
        }
        div.appendChild(span)

        const handleClick = (event: MouseEvent) => {
            maskConfig.buttonClick && maskConfig.buttonClick()
        };

        const buttonDiv = document.createElement('div')
        // buttonDiv.innerText = maskConfig.bottonText
        buttonDiv.style.background = "linear-gradient(315deg, #E4965F 0%, #D39978 100%)" 
        buttonDiv.style.minWidth = "200px"
        buttonDiv.style.height = "56px"
        buttonDiv.style.borderRadius = "4px"
        buttonDiv.style.display = "flex"
        buttonDiv.style.justifyContent = "center"
        buttonDiv.style.alignItems = "center"
        buttonDiv.style.cursor = 'pointer';
        buttonDiv.style.marginTop = "40px"
        buttonDiv.addEventListener('click', handleClick);
        div.appendChild(buttonDiv)
        buttonDiv.onmouseover = () => {
            buttonDiv.style.opacity = '0.6'; // 鼠标悬停时的背景色
        };
        
        buttonDiv.onmouseout = () => {
            buttonDiv.style.opacity = '1.0'; // 鼠标离开时的背景色
        };
        const span1 = document.createElement('span')
        span1.innerText = maskConfig.bottonText
        span1.style.color = '#FFFFFF'
        span1.style.fontSize = '18px'
        buttonDiv.appendChild(span1)
        maskConfig.paraseDiv.appendChild(div)
    }
    return div;
}

// 文本颜色修改配置接口
interface TextColorModification {
  text: string;                    // 要匹配的文本
  color: string;                   // 目标颜色
  backgroundColor?: string;         // 背景颜色 (可选)
  fontWeight?: string;             // 字体粗细 (可选)
  fontStyle?: string;              // 字体样式 (可选)
  textDecoration?: string;         // 文本装饰 (可选)
  fuzzySearch?: boolean;           // 是否启用模糊搜索
  caseSensitive?: boolean;         // 是否区分大小写
  pageRange?: {                    // 页面范围限制 (可选)
    start: number;
    end: number;
  };
  scale?: number;
  rotation?: number;
  coordinateRange?: {              // 坐标范围限制 (可选)
    x: { min: number; max: number };
    y: { min: number; max: number };
  };
}

// 全局存储文本颜色修改配置
let textColorModifications: TextColorModification[] = [];

// 设置文本颜色修改配置
export const setTextColorModificationsForLazy = (modifications: TextColorModification[]) => {
  textColorModifications = modifications;
};

// 清除所有文本颜色修改配置
export const clearTextColorModificationsForLazy = () => {
  textColorModifications = [];
  clearHighlights()
};

// 应用文本颜色修改（支持模糊匹配、坐标范围和页数限制）
export const applyTextColorModificationsForLazy = (textLayerDiv: HTMLElement, pageIndex: number) => {
    console.log("currentPageModifications", textLayerDiv, pageIndex, textColorModifications)
  if (!textLayerDiv || !textColorModifications.length) {
    return;
  }
  // 等待文本层完全渲染
  setTimeout(() => {
    // 只处理当前页码的修改
    const currentPageModifications = textColorModifications.filter(modification => {
      if (!modification.pageRange) return true;
      return pageIndex >= modification.pageRange.start && pageIndex <= modification.pageRange.end;
    });
    if (currentPageModifications.length === 0) return;

    // 应用修改到文本层
    currentPageModifications.forEach(modification => {
      const elements = findElementsWithText(textLayerDiv, modification.text, modification);
      console.log("elements", elements)
      if (elements.length > 1) {
        // 需要做范围判断
        for (let i = 0; i < elements.length; ++i) {
          let element = elements[i]
          if (!isInCoordinateRange(textLayerDiv,element, pageIndex, modification.coordinateRange, modification.rotation)) {
            elements.splice(i, 1)
            i--
          }
        }
      }
      elements.forEach(element => {
        // 检查坐标范围
        // if (!isInCoordinateRange(textLayerDiv,element, pageIndex, modification.coordinateRange, modification.rotation)) {
        //   return;
        // }
        console.log("findElementsWithText", element.textContent)
        // 应用颜色修改
        if (modification.color) {
          element.style.color = modification.color;
        }
        
        // 应用背景颜色
        if (modification.backgroundColor) {
          element.style.backgroundColor = modification.backgroundColor;
        }
        
        // 应用字体粗细
        if (modification.fontWeight) {
          element.style.fontWeight = modification.fontWeight;
        }
        
        // 应用字体样式
        if (modification.fontStyle) {
          element.style.fontStyle = modification.fontStyle;
        }
        
        // 应用文本装饰
        if (modification.textDecoration) {
          element.style.textDecoration = modification.textDecoration;
        }
      });
    });
  }, 200);
};

// 计算字符串相似度（Levenshtein距离）
const levenshteinDistance = (str1: string, str2: string): number => {
  const matrix: number[][] = [];
  for (let i = 0; i <= str2.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= str1.length; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= str2.length; i++) {
    for (let j = 1; j <= str1.length; j++) {
      if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[str2.length][str1.length];
};

// 计算字符串相似度百分比
const calculateSimilarity = (str1: string, str2: string): number => {
  const distance = levenshteinDistance(str1, str2);
  const maxLength = Math.max(str1.length, str2.length);
  return maxLength === 0 ? 1 : (maxLength - distance) / maxLength;
};

// 模糊匹配文本
const fuzzyMatch = (text: string, searchText: string, threshold: number = 0.05): boolean => {
  if (!searchText || !text) return false;
  
  // 转换为小写进行比较（除非指定区分大小写）
  const lowerText = text.toLowerCase();
  const lowerSearchText = searchText.toLowerCase();

  console.log("fuzzyMatch", lowerText, "lowerSearchText====", lowerSearchText)
  let str = lowerSearchText.replaceAll("\\n", "\n").replaceAll("\\t", "\t").replaceAll(/\s+/g, '')
  console.log("fuzzyMatch=====", str)
  // 精确匹配
  if (lowerText.includes(lowerSearchText) || lowerSearchText.includes(lowerText)) {
    return true;
  }
  // 模糊匹配
  const similarity = calculateSimilarity(lowerText, lowerSearchText);
  return similarity >= threshold;
};

// 检查元素是否在指定坐标范围内（使用PDF原始坐标）
const isInCoordinateRange = (textLayerDiv: HTMLElement, element: HTMLElement, pageIndex: number, coordinateRange?: { x: { min: number; max: number }; y: { min: number; max: number }}, rotation?: number): boolean => {
  if (!coordinateRange) return true;
  
  const rect = element.getBoundingClientRect();
  const textLayerRect = textLayerDiv.getBoundingClientRect();

  const viewPage = viewPages[pageIndex];
  // const point = getUnrotatedPosition(element, textLayerDiv, scale1) 

  // let div = document.createElement('div')
  // div.style.width = point?.width + 'px'
  // div.style.height = point?.height + 'px'
  // div.style.position = 'absolute'
  // div.style.left = (viewPage.width - point?.x - point?.width) * scale1 + 'px'
  // div.style.top = (viewPage.height - point?.y - point?.height) * scale1 + 'px'
  // div.style.backgroundColor = 'red'
  // textLayerDiv.appendChild(div)

  if (!viewPage) {
    console.warn(`ViewPage not found for page index: ${pageIndex}`);
    return true;
  }
  
  let newAdjustedCoordinateRange = {
    x: {
      min: coordinateRange.x.min,
      max: coordinateRange.x.max
    },
    y: {
      min: viewPage.height -  coordinateRange.y.max,
      max: viewPage.height -  coordinateRange.y.min
    }
  }

  const scale = textLayerRect.width / viewPage.width;
  
  // 计算元素相对于文本层的坐标
  const relativeX = Math.ceil(rect.left - textLayerRect.left);
  const relativeY = Math.ceil(rect.top - textLayerRect.top);
  
  // 将当前渲染坐标转换为PDF原始坐标
  let pdfOriginalX = Math.ceil(relativeX / scale);
  let pdfOriginalY = Math.ceil(relativeY / scale);
  
  // 获取页面旋转角度
  const pageRotation = viewPage.rotation || 0;
  
  // 获取文本旋转角度（如果没有传入，默认为0）
  const textRotation = rotation || 0;
  
  // 计算文本元素的尺寸
  const elementWidth = newAdjustedCoordinateRange.x.max - newAdjustedCoordinateRange.x.min;
  const elementHeight = newAdjustedCoordinateRange.y.max - newAdjustedCoordinateRange.y.min;
  
  // 计算文本元素的四个角点坐标（以左下角为中心）
  const textCorners = [
    { x: pdfOriginalX, y: pdfOriginalY }, // 左下角（旋转中心）
    { x: pdfOriginalX + elementWidth, y: pdfOriginalY }, // 右下角
    { x: pdfOriginalX + elementWidth, y: pdfOriginalY + elementHeight }, // 右上角
    { x: pdfOriginalX, y: pdfOriginalY + elementHeight } // 左上角
  ];
  
  // 定义旋转函数（以左下角为中心）
  const rotatePoint = (point: {x: number, y: number}, angle: number, center: {x: number, y: number}) => {
    const radians = angle * Math.PI / 180;
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);
    
    // 相对于旋转中心的坐标
    const x = point.x - center.x;
    const y = point.y - center.y;
    
    // 应用旋转矩阵
    const rotatedX = x * cos - y * sin;
    const rotatedY = x * sin + y * cos;
    
    // 转换回绝对坐标
    return {
      x: rotatedX + center.x,
      y: rotatedY + center.y
    };
  };
  
  // 定义逆向旋转函数（用于将旋转后的坐标转换回原始坐标）
  const reverseRotatePoint = (point: {x: number, y: number}, angle: number, center: {x: number, y: number}) => {
    const radians = -angle * Math.PI / 180; // 使用负角度进行逆向旋转
    const cos = Math.cos(radians);
    const sin = Math.sin(radians);
    
    // 相对于旋转中心的坐标
    const x = point.x - center.x;
    const y = point.y - center.y;
    
    // 应用逆向旋转矩阵
    const originalX = x * cos - y * sin;
    const originalY = x * sin + y * cos;
    
    // 转换回绝对坐标
    return {
      x: originalX + center.x,
      y: originalY + center.y
    };
  };
  
  // 处理页面旋转
  let adjustedCoordinateRange = newAdjustedCoordinateRange;
  let adjustedTextCorners = textCorners;
  // 根据页面旋转角度调整坐标范围
  switch (pageRotation) {
    case 0:
      // 无旋转，直接使用原始坐标范围
      
      break;
      
    case 90:
      // 顺时针旋转90度
      const point = getUnrotatedPosition(element, textLayerDiv) 
      pdfOriginalX = (viewPage.height - (point?.y + point?.height) / scale )
      pdfOriginalY = ((viewPage.width - (point?.x + point?.width)/ scale )) - elementHeight

      console.log("isIntersect", pdfOriginalX, pdfOriginalY, newAdjustedCoordinateRange, point)

      let div = document.createElement('div')
      div.style.width = elementWidth * scale + 'px'
      div.style.height = elementWidth * scale + 'px'
      div.style.position = 'absolute'
      div.style.left = point.x + 'px'
      div.style.top = point.y+ 'px'
      div.style.backgroundColor = 'red'
      textLayerDiv.appendChild(div)

      // let div1 = document.createElement('div')
      // div1.style.width = elementHeight * scale + 'px'
      // div1.style.height = elementWidth * scale + 'px'
      // div1.style.position = 'absolute'
      // div1.style.left = adjustedCoordinateRange.y.min * scale + 'px'
      // div1.style.top = adjustedCoordinateRange.x.min * scale + 'px'
      // div1.style.backgroundColor = 'blue'
      // textLayerDiv.appendChild(div1)
      break;
      
    case 180:
      const point1 = getUnrotatedPosition(element, textLayerDiv) 
      pdfOriginalX = (viewPage.width - (point1?.x + point1?.width) / scale )
      pdfOriginalY = ((viewPage.height - (point1?.y + point1?.height)/ scale )) - elementHeight

      console.log("isIntersect", pdfOriginalX, pdfOriginalY)
      // console.log("point", point, (viewPage.width * scale - (point?.x + point?.width)), 
      // (viewPage.height * scale - (point?.y + point?.height)), elementWidth, elementHeight, scale)
      // let div = document.createElement('div')
      // div.style.width = elementWidth * scale + 'px'
      // div.style.height = point?.height + 'px'
      // div.style.position = 'absolute'
      // div.style.left = (viewPage.width * scale - (point?.x + point?.width) ) + 'px'
      // div.style.top = (viewPage.height * scale - (point?.y + point?.height)) - elementHeight * scale + 'px'
      // div.style.backgroundColor = 'red'
      // textLayerDiv.appendChild(div)

      // let div1 = document.createElement('div')
      // div1.style.width = elementWidth * scale + 'px'
      // div1.style.height = elementHeight * scale + 'px'
      // div1.style.position = 'absolute'
      // div1.style.left = adjustedCoordinateRange.x.min * scale + 'px'
      // div1.style.top = adjustedCoordinateRange.y.min * scale + 'px'
      // div1.style.backgroundColor = 'blue'
      // textLayerDiv.appendChild(div1)
      
      break;

    case 270:
      // 顺时针旋转270度（逆时针90度）
      const point2 = getUnrotatedPosition(element, textLayerDiv) 
      pdfOriginalX = (viewPage.width - (point2?.x + point2?.width) / scale )
      pdfOriginalY = ((viewPage.height - (point2?.y + point2?.height)/ scale )) - elementHeight
      break;
      
    default:
      console.warn(`Unsupported rotation angle: ${pageRotation}`);
      return true;
  }
  
  // 检查文本的四个角点是否在调整后的范围内
  // let isInRange = pdfOriginalX >= adjustedCoordinateRange.x.min && 
  //          pdfOriginalX <= adjustedCoordinateRange.x.max && 
  //          pdfOriginalY >= adjustedCoordinateRange.y.min && 
  //          pdfOriginalY <= adjustedCoordinateRange.y.max;

  let isInRange = isRectIntersect( {
    x: pdfOriginalX,
    y: pdfOriginalY,
    width: elementWidth,
    height: elementHeight
  }, {
    x: adjustedCoordinateRange.x.min,
    y: adjustedCoordinateRange.y.min,
    width: elementWidth,
    height: elementHeight
  })
  // 调试信息
  console.log("坐标转换:", {
    viewPage,
    pageRotation,
    textRotation,
    currentX: relativeX,
    currentY: relativeY,
    pdfOriginalX: pdfOriginalX,
    pdfOriginalY: pdfOriginalY,
    scale: scale,
    elementWidth: elementWidth,
    elementHeight: elementHeight,
    originalCoordinateRange: newAdjustedCoordinateRange,
    adjustedCoordinateRange: adjustedCoordinateRange,
    textCorners: textCorners,
    adjustedTextCorners: adjustedTextCorners,
    isInRange: isInRange,
    text: element.textContent,
    el: element
  });
  
  return isInRange;
};

// 递归查找所有文本节点
const findTextNodes = (element: HTMLElement): Text[] => {
  const textNodes: Text[] = [];
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    null
  );

  let node;
  while (node = walker.nextNode()) {
    textNodes.push(node as Text);
  }

  return textNodes;
};

// 查找包含指定文本的所有元素
const findElementsWithText = (textLayerDiv: HTMLElement, searchText: string, option: TextColorModification): HTMLElement[] => {
  const elements: HTMLElement[] = [];
  const textNodes = findTextNodes(textLayerDiv);
 
  // 先组合所有拿到的字符串
  let textContentAll = textNodes.map(textNode => textNode.textContent).join("").replaceAll("\\n", "\n").replaceAll("\\t", "\t").replaceAll(/\s+/g, '')
  let findText = searchText.replaceAll("\\n", "\n").replaceAll("\\t", "\t").replaceAll(/\s+/g, '')

  // 这里记录每个文本的下标
  let allTextIndexs: number[] = []
  let index = 0
  textNodes.forEach(textNode => {
    let textContent = textNode.textContent || ''
    textContent = textContent.replaceAll("\\n", "\n").replaceAll("\\t", "\t").replaceAll(/\s+/g, '')
    textContent.split("").forEach(text => {
      allTextIndexs.push(index)
    })
    index += 1
  })
  // 记录找到的文本下表 可能多个
  let indexPos: number[] = []
  let startIndex = textContentAll.indexOf(findText)
  while(startIndex !== -1) {
    indexPos.push(startIndex)
    startIndex = textContentAll.indexOf(findText, startIndex + 1)
  }
  // 这里找到了选择
  if (indexPos.length > 0) {
    // 找到的相同文本大于1个则需要单独做处理
    if (indexPos.length > 1) {
      // 需要做判断
      for (let i = indexPos.length - 1; i > 0; --i) {
        let curIndex = indexPos[i]
        if (curIndex > 0 && allTextIndexs[curIndex] == allTextIndexs[curIndex - 1]) {
            console.log("curIndex 删除了一条", curIndex, allTextIndexs[curIndex], allTextIndexs[curIndex - 1])
            // 删除curIndex
            indexPos.splice(i, 1)
        } else if (curIndex < textContentAll.length - 1 && curIndex + findText.length + 1 < textContentAll.length 
            && allTextIndexs[curIndex] == allTextIndexs[curIndex + findText.length + 1]) {
            // 删除curIndex
            console.log("curIndex 删除了一条===", curIndex, textContentAll.length, allTextIndexs[curIndex], allTextIndexs[curIndex + 1])
            indexPos.splice(i, 1)
        }
      }
    }
    // 这里如果找到1个以上 匹配之后处理
    if (indexPos.length > 1 ){
      for (let i = indexPos.length - 1; i >= 0; --i) {
        let curIndex = indexPos[i]
        for (let j = curIndex; j < curIndex + findText.length; ++j) {
            if (allTextIndexs[j] !== allTextIndexs[j + 1]) {
              indexPos.push(j)
            }
        }
      }
      // 需要做范围坐标判断 [ 10，20，10，10 ]
      indexPos.forEach(pos => {
        // 这里找到相应的 textNode 下标
        let findIndex = allTextIndexs[pos]
        // 获取当前text
        let element = textNodes[findIndex].parentElement
        console.log("indexPos", pos, allTextIndexs)
        while(element && element !== textLayerDiv) {
          if (element.nodeType === Node.ELEMENT_NODE) {
            elements.push(element as HTMLElement);
          }
          element = element.parentElement;
        }
      })
    }else if (indexPos.length === 1) {
      for (let j = indexPos[0]; j < indexPos[0] + findText.length; ++j) {
        if (allTextIndexs[j] !== allTextIndexs[j + 1]) {
          indexPos.push(j)
        }
      }
      // 只有一个则不需要坐标判断
      indexPos.forEach(pos => {
        // 这里找到相应的 textNode 下标
        let findIndex = allTextIndexs[pos]
        // 获取当前text
        let element = textNodes[findIndex].parentElement
        console.log("indexPos", pos, allTextIndexs)
        while(element && element !== textLayerDiv) {
          if (element.nodeType === Node.ELEMENT_NODE) {
            elements.push(element as HTMLElement);
          }
          element = element.parentElement;
        }
      })
    }
  }else {
    // 没有匹配的选项
    return []
  }
  return elements;
};

// 清除所有高亮
export const clearHighlights = () => {
  let textLayerDiv = document.getElementById(`right-canvas-textLayer-${lastPageIndex}`)
  console.log("clearHighlights", textLayerDiv, lastPageIndex)
  if (!textLayerDiv) {
    return;
  }

  const allElements = textLayerDiv.querySelectorAll('*');
  allElements.forEach(element => {
    const el = element as HTMLElement;
    el.style.backgroundColor = '';
    el.style.color = '';
    el.style.fontWeight = '';
    el.style.fontStyle = '';
    el.style.textDecoration = '';
  });
};

export const setLastPageIndex = (pageIndex: number) => {
  lastPageIndex = pageIndex
};


function restoreRotatedRectangle(rotatedCorners, angle, rotationCenter) {
    // 如果没有提供旋转中心，则计算旋转后矩形的中心点
    const center = rotationCenter;
    
    // 计算逆向旋转的三角函数值
    const cosTheta = Math.cos(-angle);
    const sinTheta = Math.sin(-angle);
    
    // 对每个顶点应用逆向旋转
    return rotatedCorners.map(corner => {
        // 平移至原点
        const translatedX = corner.x - center.x;
        const translatedY = corner.y - center.y;
        
        // 应用逆向旋转
        const originalX = translatedX * cosTheta - translatedY * sinTheta;
        const originalY = translatedX * sinTheta + translatedY * cosTheta;
        
        // 平移回原位置
        return {
            x: originalX + center.x,
            y: originalY + center.y
        };
    });
}



const getUnrotatedPosition = (rotatedElement, parentContainer) => {
  if (!rotatedElement || !parentContainer) return;

  // 1. 创建克隆元素（不包含旋转样式）
  const clone = rotatedElement.cloneNode(true);
  clone.style.transform = 'none';
  clone.style.transformOrigin = 'left bottom';
  clone.style.position = 'absolute';
  clone.style.visibility = 'hidden';
  
  // 2. 临时添加到父容器中测量
  parentContainer.appendChild(clone);
  
  // 3. 获取相对于父容器的位置
  const parentRect = parentContainer.getBoundingClientRect();
  const cloneRect = clone.getBoundingClientRect();
  
  let position = {
    x: cloneRect.left - parentRect.left,
    y: cloneRect.top - parentRect.top,
    width: cloneRect.width,
    height: cloneRect.height
  };
  
  // 4. 移除克隆元素
  parentContainer.removeChild(clone);

  return position
};

function isRectIntersect(rect1, rect2) {
  // 判断水平方向是否相交
  if (rect1.x + rect1.width < rect2.x || rect2.x + rect2.width < rect1.x) {
    return false;
  }
  // 判断垂直方向是否相交
  if (rect1.y + rect1.height < rect2.y || rect2.y + rect2.height < rect1.y) {
    return false;
  }
  // 满足上述条件则相交
  return true;
}